import themeConfig from "@package/util/config/themeConfig.json";

export function createThemeAppConfig({
  appName,
  themeId,
  themeVariant,
  displayName,
  theme,
  surfaces,
  bodyColor,
}) {
  const appTheme = {
    ...themeConfig.themeConfig,
    variant: themeVariant,
    ...theme,
  };

  const colors = {
    primary: appTheme.primaryColor,
    secondary: appTheme.secondaryColor,
    background: appTheme.backgroundColor,
    heading: appTheme.headingColor || appTheme.primaryColor,
    text: appTheme.textColor || appTheme.primaryColor,
    body:
      bodyColor ||
      appTheme.subHeadingTextColor ||
      appTheme.lightTextColor ||
      appTheme.textColor ||
      themeConfig.themeConfig.lightTextColor,
    accent: appTheme.accentColor || appTheme.secondaryColor,
    buttonBackground: appTheme.buttonColor || appTheme.primaryColor,
    buttonText:
      appTheme.buttonTextColor || themeConfig.themeConfig.buttonTextColor,
    searchBorder: appTheme.searchBorder || themeConfig.themeConfig.borderColor,
  };

  const muiTheme = {
    palette: {
      primary: {
        main: appTheme.muiPrimaryColor || colors.primary,
      },
      secondary: {
        main: appTheme.muiSecondaryColor || colors.secondary,
      },
    },
    typography: {
      fontFamily: "Poppins, sans-serif",
    },
  };

  return {
    appName,
    themeId,
    themeVariant,
    displayName,
    theme: appTheme,
    colors,
    surfaces,
    muiTheme,
  };
}
